var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon, Select } from 'shared/components/ui';
import { useInvoices } from 'src/shared/features/ProviderPay';
import { useNavigate } from 'react-router-dom';
import { PrintWrapper, StatusWrapper } from 'src/shared/components';
import { EditSelect } from 'shared/assets/icons';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { EHR_DATE_FORMAT, MONTH_DAY_YEAR_FORMAT, SHORT_MONTH_DAY_FORMAT } from '../constants';
export var PaymentSelector = function (_a) {
    var providerId = _a.providerId, currentInvoice = _a.currentInvoice;
    var _b = useInvoices({
        enabled: providerId.length > 0,
        providerId: providerId,
    }), data = _b.data, isError = _b.isError, isLoading = _b.isLoading;
    var start = currentInvoice.period_start
        ? DateTime.fromFormat(currentInvoice.period_start, EHR_DATE_FORMAT)
        : null;
    var end = currentInvoice.period_end
        ? DateTime.fromFormat(currentInvoice.period_end, EHR_DATE_FORMAT)
        : null;
    var currentPeriod = "".concat(start === null || start === void 0 ? void 0 : start.toFormat(SHORT_MONTH_DAY_FORMAT), " - ").concat(end === null || end === void 0 ? void 0 : end.toFormat(MONTH_DAY_YEAR_FORMAT));
    var navigate = useNavigate();
    var options = useMemo(function () {
        var _a, _b;
        return __spreadArray([
            _jsx("option", __assign({ value: "", disabled: true, selected: true, hidden: true }, { children: currentPeriod }), "currentPeriod")
        ], ((_b = (_a = data === null || data === void 0 ? void 0 : data.invoices) === null || _a === void 0 ? void 0 : _a.map(function (invoice) {
            var period = "".concat(invoice.period_start
                ? DateTime.fromFormat(invoice.period_start, EHR_DATE_FORMAT).toFormat('d')
                : '', "-").concat(invoice.period_end
                ? DateTime.fromFormat(invoice.period_end, EHR_DATE_FORMAT).toFormat('d MMM, yyyy')
                : '', "\n        ");
            return (_jsx("option", __assign({ value: "/pay/invoice/".concat(invoice.id), "data-testid": "option" }, { children: period }), invoice.id));
        })) !== null && _b !== void 0 ? _b : []), true);
    }, [data === null || data === void 0 ? void 0 : data.invoices]);
    return (_jsxs(StatusWrapper, __assign({ isError: isError, isLoading: isLoading }, { children: [_jsx(Select, __assign({ "data-testid": "payments-select", width: "fit-content", variant: "pageSelect", zIndex: 1, icon: _jsx(_Fragment, {}), onChange: function (event) { return navigate(event.target.value); } }, { children: options })), _jsx(PrintWrapper, __assign({ hideWhenPrint: true }, { children: _jsxs(Button, __assign({ "data-testid": "change-button", mt: -14, p: 0, pt: 1, variant: "links", _groupHover: {
                        color: 'green.600',
                    } }, { children: ["Change payment ", _jsx(Icon, { boxSize: 4, as: EditSelect })] })) }))] })));
};
